var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info",class:_vm.optionalClass},[(_vm.hasIcon)?_vm._t("icon",function(){return [_vm._v("icon")]}):_vm._e(),_vm._v(" "),_vm._t("keyLabel",function(){return [_vm._v("keyLabel")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }